import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  list: {},
  scrollIndex: 0,
  arraySelector: []
};

export const basket = createSlice({
  name: 'basket',
  initialState,
  reducers: {
    setList: (state, action) => ({
      ...state,
      list: action.payload
    }),
    setScrollIndex: (state, action) => ({
      ...state,
      scrollIndex: action.payload
    }),
    setArraySelector: (state, action) => ({
      ...state,
      arraySelector: action.payload
    }),
  },
  effects: () => ({}),
});

export const { setList, setScrollIndex, setArraySelector } = basket.actions;
export const selectList = (state) => state.basket.list;
export const arraySelector = (state) => state.basket.arraySelector;

export default basket.reducer;